import styled from 'styled-components';

import loader from '../../../svg/dot-preloader.svg';

export const WrongPasswordSupportAlert = styled.div<{ isVisible: boolean }>`
  position: absolute;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #1e1d22;
  color: #fff;
  padding: 40px;
  left: ${(props) => (props.isVisible ? '417px' : 0)};
  top: 40px;
  width: 343px;
  height: 250px;
  display: flex;
  z-index: 0;
  transition: 0.3s;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  @media screen and (max-width: 1300px) {
    z-index: ${(props) => (props.isVisible ? 1 : 0)};
    left: 50%;
    top: 23px;
    border-radius: 4px;
    transform: translateX(-50%);
    background: rgba(0, 0, 0, 0.8);
    width: 288px;
    height: 288px;
  }
  .error-header {
    color: #ffcc05;
    line-height: 26px;
    font-size: 21px;
  }
  .error-main {
    margin-top: 10px;
    color: #ebebeb;
    font-size: 15px;
    font-style: italic;
  }
  .error-main-2 {
    margin-top: 2px;
    color: #ebebeb;
    font-size: 15px;
    font-style: italic;
  }
  .error-phone {
    margin-top: 40px;
    align-items: center;
    justify-content: center;
    display: flex;
    font-size: 17px;
    & img {
      width: 18px;
      height: 18px;
      color: #fff;
      margin-right: 10px;
    }
  }
  .error-mail {
    margin-top: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    text-decoration: underline;
    & img {
      width: 18px;
      height: 18px;
      color: #fff;
      margin-right: 10px;
    }
    & a {
      color: #fff;
    }
  }
`;

export const Background = styled.div`
  background: #fff;
  background-size: cover;
`;

export const Title = styled.div`
  color: #1e1d22;
  position: relative;
  font-size: 29px;
  text-align: center;
  margin: 50px 0 35px;
`;

export const SModalBody = styled.div`
  position: relative;
  padding-left: 75px;
  padding-right: 75px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #fff;
  z-index: 1;
  border-radius: 4px;
  .form-group {
    margin-bottom: 0 !important;
  }
  @media screen and (max-width: 768px) {
    padding: 0 30px;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  border: none;
  border-radius: 4px;
  padding-top: 2px;
  padding-bottom: 2px;
  position: relative;
  max-width: 320px;
  margin: auto;
  margin-bottom: 15px;
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 30px white inset !important;
  }
  input {
    height: 50px;
    border: 1px solid #ebebeb;
    filter: none;
    &:focus {
      border-color: #ffcc05 !important;
      box-shadow: none !important;
    }
    &:hover {
      border-color: #ffcc05 !important;
    }
  }
  background-color: #fff !important;
  &:focus {
    background-color: #fff !important;
  }
`;

export const Input = styled.input`
  box-shadow: none !important;
  outline: none !important;
  width: 100%;
  padding: 0 10px 0 10px;
`;

export const Img = styled.img<{ isPassword?: boolean }>`
  width: 22px;
  height: 22px;
  top: 16px;
  right: 10px;
  position: absolute;
  cursor: ${(props) => (props.isPassword ? 'pointer' : 'default')};
`;

interface IButtonProps {
  hasLoader: boolean;
  disabled: boolean;
}

export const EntranceButton = styled.button<IButtonProps>`
  display: block;
  z-index: 5;
  border-radius: 4px;
  cursor: pointer;
  color: #fff !important;
  background-color: #03548b;
  font-size: 19px !important;
  position: relative;
  text-decoration: none !important;
  height: 50px;
  top: 25px;
  transition: 0.3s;
  border: none;
  width: 100%;
  max-width: 320px;
  margin: 10px auto 40px;
  &::before {
    content: '';
    display: block;
    background-size: cover;
    position: absolute;
    width: ${({ hasLoader }) => (hasLoader ? '25px' : '7px')};
    height: ${({ hasLoader }) => (hasLoader ? '25px' : '12px')};
    top: ${({ hasLoader }) => (hasLoader ? '50%' : '24px')};
    right: 10px;
    transform: translateY(-50%);
    pointer-events: none;
    background-repeat: no-repeat;
    z-index: 10;
    background-image: url(${({ hasLoader }) => (hasLoader ? loader : '#fff')});
  }
  &:disabled {
    opacity: ${({ disabled }) => (disabled ? '.5 !important' : '1 !important')};
  }
  &.hidden {
    visibility: hidden;
  }
`;

export const SModal = styled.div`
  width: 425px;
  height: 490px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  border: 1px solid #f1f1f1;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 3px;
  @media screen and (max-width: 768px) {
    width: auto;
    height: auto;
  }
`;

export const Form = styled.form`
  .create-links {
    text-align: center;
    .register-link {
      font-size: 18px;
      color: #0093dd;
      cursor: pointer;
      margin-top: 7px;
    }
  }
`;

export const FormGroup = styled.div``;

export const Back = styled.span`
  color: #999;
  position: absolute;
  cursor: pointer;
  font-size: 17px;
  left: 34px;
  top: 8px;
  transition: 0.3s ease-in-out;
  &:hover {
    color: #888;
  }
`;

export const PrivatePolicy = styled.div`
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  z-index: 99999;
  background: rgba(0, 0, 0, 0.5);
`;

export const Bottom = styled.div`
  display: flex;
  flex-direction: column;
  position: absolute;
  left: 0;
  width: 100%;
  bottom: -55px;
`;

export const Link = styled.div`
  text-align: center;
  color: #444;
  cursor: pointer;
  font-size: 14px;
  transition: 0.3s ease-in-out;
  &:hover {
    color: #0093dd;
  }
`;
